/**
 * CommunitySignals — dark card showing live community activity.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../utils/constants';

export interface CommunitySignal {
  name: string;
  initials: string;
  avatarColor: string;
  action: string;
  timeAgo: string;
  isNew?: boolean;
}

interface CommunitySignalsProps {
  signals: CommunitySignal[];
  title?: string;
  fullWidthCta?: boolean;
}

export const CommunitySignals: React.FC<CommunitySignalsProps> = ({
  signals,
  title = '🔴 Live in your community',
  fullWidthCta = false,
}) => {
  return (
    <div
      className="rounded-2xl p-5"
      style={{
        background: 'linear-gradient(135deg, #1e1e2e, #2d2d42)',
        border: '1.5px solid rgba(255,255,255,0.06)',
      }}
    >
      <p className="font-montserrat font-bold text-sm text-white mb-4">{title}</p>

      <div className="space-y-3 mb-4">
        {signals.map((signal, i) => (
          <div key={i} className="flex items-center gap-3">
            {/* Avatar */}
            <div
              className="w-8 h-8 rounded-full flex items-center justify-center font-montserrat font-bold text-xs text-white flex-shrink-0"
              style={{ background: signal.avatarColor }}
            >
              {signal.initials}
            </div>

            {/* Text */}
            <div className="flex-1 min-w-0">
              <p className="font-open-sans text-xs text-neutral-300 leading-snug">
                <span className="text-white font-semibold">{signal.name}</span>{' '}
                {signal.action}
              </p>
              <p className="font-open-sans text-xs text-neutral-500">{signal.timeAgo}</p>
            </div>

            {/* New badge */}
            {signal.isNew && (
              <span
                className="flex-shrink-0 px-2 py-0.5 rounded-full font-montserrat font-bold text-white"
                style={{
                  background: '#00c2a8',
                  fontSize: '10px',
                  lineHeight: '1.4',
                }}
              >
                New
              </span>
            )}
          </div>
        ))}
      </div>

      <Link
        to={ROUTES.community}
        className={`font-open-sans text-sm font-semibold transition-opacity hover:opacity-80 ${
          fullWidthCta
            ? 'block w-full text-center py-2.5 rounded-full text-white'
            : ''
        }`}
        style={
          fullWidthCta
            ? { background: 'linear-gradient(135deg, #00b89a, #00c2a8)', color: '#fff' }
            : { color: '#00c2a8' }
        }
      >
        Join the conversation →
      </Link>
    </div>
  );
};
